<template>
    <div id="veehicle_types_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehicleTypeHeader" v-if="$route.params.id > 0">Update Asset Type</span>
                    <span class="page-title" id="vehicleTypeHeader" v-else>Add Asset Type</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehicleList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content asset-type-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="VehicleTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Display Order:</label>
                                        <input type="text" class="form-control" v-model="typeOrder" id="type_order" placeholder="Enter display order" name="type_order">
                                        <div class="field-error">{{type_order_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Type URL:</label>
                                        <input type="text" class="form-control" v-model="typeUrl" id="type_url" placeholder="Enter Type Url" name="type_url">
                                        <div class="field-error"></div>
                                    </div>
                                    <!-- <div class="col form-group">
                                        <label class="control-label" for="name">Deposit Required:</label>
                                        <input type="text" class="form-control" v-model="deposit_required" id="deposit_required" placeholder="Enter Required Deposit" name="deposit_required" @keypress="isAmountCheck($event)">
                                        <div class="field-error"></div>
                                    </div> -->
                                    <div class="col form-group">
                                        <label class="control-label require" for="truck_type">Truck Type</label>
                                        <v-select v-model="truck_type" name="truck_type" placeholder="Select Truck Type."
                                                label="text"
                                                :options="ttArr" id="truck_type">
                                        </v-select>
                                        <div class="field-error">{{truck_type_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="trailor_type">Trailer Type</label>
                                        <v-select v-model="trailor_type" name="trailor_type" placeholder="Select Trailor Type."
                                                label="text"
                                                :options="trailorTypeArr" id="trailor_type">
                                        </v-select>
                                        <div class="field-error">{{trailor_type_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Specification:</label>
                                        <textarea class="form-control" v-model="specification" id="specification" rows="5" placeholder='Enter "," seperated Specifications' name="specification">
                                        </textarea>
                                        <div class="field-error">{{specification_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label" for="name">Image (JPEG,JPG,PNG):</label> <br/>
                                        <input id="typeImage" type="file" @change="onFileChanged">
                                        <div class="mt-4" v-if="img_path != '' || baseimg_path != null">
                                            <img v-bind:src="img_path" width="200px" height="200px" alt="" v-if="img_path != '' && baseimg_path == null" />
                                            <img v-bind:src="baseimg_path" width="200px" height="200px" alt="" v-else/>
                                        </div>
                                        <div class="field-error">{{img_error_msg}}</div>
                                    </div>
                                </div>
                                <div v-if="rows && rows.length > 0" class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="w-50 require">Section</th>
                                                <th scope="col" class="w-25 require">Read On Wo</th>
                                                <th scope="col" class="w-25 require">Read On Contract</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(read, index) in rows" :key="index">
                                                <td>
                                                    <v-select class="section-id" v-model="read.section" name="rate_section" placeholder="Select Section Rate"
                                                        label="text"
                                                        :options="sectionArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.section_error_msg }}</div>
                                                </td>
                                                <td>
                                                    <v-select class="section-id" v-model="read.read_on_wo" name="read_on_wo" placeholder="Select Read On Wo"
                                                        label="text"
                                                        :options="readOnArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.read_on_wo_error_msg }}</div>
                                                </td>
                                                <td>
                                                    <v-select class="section-id" v-model="read.read_on_contract" name="read_on_contract" placeholder="Select Read On Contract"
                                                        label="text"
                                                        :options="readOnArr">
                                                    </v-select>
                                                    <div class="field-error">{{ read.read_on_contract_error_msg }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click.prevent="removeElement(index);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Line Item
                                        </button>
                                    </div>
                                </div>

                                <!-- <h5>Deposit</h5>
                                <div v-if="deprows && deprows.length > 0" class="table-responsive-sm">
                                    <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                        <thead>
                                            <tr class="table-primary">
                                                <th scope="col" class="w-50 require">Pool</th>
                                                <th scope="col" class="w-25 require">Deposit</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(dep, depindex) in deprows" :key="depindex">
                                                <td>
                                                    <v-select class="section-id" v-model="dep.pool" name="pool" placeholder="Select Pool"
                                                        label="text"
                                                        :options="assetPoolArr">
                                                    </v-select>
                                                    <div class="field-error">{{ dep.pool_error_msg }}</div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" v-model="dep.deposit_required" id="deposit_required" placeholder="Enter Required Deposit" name="deposit_required" @keypress="isAmountCheck($event)">
                                                    <div class="field-error">{{ dep.deposit_error_msg }}</div>
                                                </td>
                                                <td class="text-center valign-middle">
                                                    <template v-if="rows.length != 1">
                                                         <a href="javascript:void(0)" v-on:click.prevent="removeDepElement(depindex);"> <i class="fp-remove"></i> </a>
                                                    </template>
                                                    <template v-else>
                                                        <span class="close-row"> _ </span>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div class="btn-groups">
                                        <button type="submit" v-on:click.prevent="addDepRow()" class="btn btn-primary">
                                            <i class="fp-add"></i> Add Deposit Line
                                        </button>
                                    </div>
                                </div> -->
                                <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                    <strong id="errorMsg" class="field-error"></strong>
                                </div>
                                <div class="btn-groups mt-4">
                                    <button type="submit" id="createVehicleTypeBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateVehicleType" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehicleTypeBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateVehicleType" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehicleTypeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehicleType(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelVehicleTypeBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehicleList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "VehicleTypeCreate",
  
  mixins:[commonMixins,contractMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Type | " +process.env.COPYRIGHT_NAME : "Create Asset Type | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    code: "",
    typeUrl:"",
    deposit_required: '',
    typeOrder:"",
    checkboxValue: 0,
    is_default: "",
    loading:false,
    vehicle_count: [],
    name_error_msg: "",
    code_error_msg: "",
    specification_error_msg: "",
    type_order_error_msg:"",
    baseimg_path:null,
    img_path:"",
    fullPath:"",
    selectedFile:[],
    img_error_msg:"",
    specification:"",
    rows:[],
    // deprows:[],
    sectionArr:[],
    assetPoolArr:[],
    // readOnArr:[{text:'Do Not Read',value:'do not read'},
    //     {text:'Optional',value:'optional'},
    //     {text:'Mandatory',value:'mandatory'}],
    readOnArr:[{text:'Mandatory',value:'mandatory'}, {text:'Skip',value:'skip'}],
    truck_type:'',
    trailor_type:'',
    ttArr:[{text:'Trailor',value:'trailor'},
                    {text:'2x',value:'2x'},
                    {text:'3x',value:'3x'},
                    {text:'4x',value:'4x'},
                    {text:'Ligh Duty',value:'light_duty'},
                    {text:'26k',value:'26k'},{text:'33k',value:'33k'},
                    {text:'3-Axle Straight Truck',value:'3 axle straight'},{text:'Specialty',value:'speciality'}],
    trailorTypeArr:[{text:'Dryvan',value:'dryvan'},
                    {text:'Stakebed/Flatbed',value:'stakebed'},
                    {text:'Sleeper',value:'sleeper'},
                    {text:'Reefer',value:'reefer'},{text:'Daycab',value:'daycab'},
                    {text:'Specialty',value:'speciality'}],
    trailor_type_error_msg:'',
    truck_type_error_msg:'',
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_type') {
                        self.cantAccessPage = true;
                    }
                }
            }
        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        // alert(process.env.ROOT_API);
      /*  var path = process.env.ROOT_API;
        var pathArr = path.split('/');
        console.log(pathArr);
        self.fullPath = pathArr[0]+'//'+pathArr[2] + "/";*/
        // self.getVehiclCode();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadVehicleTypes();
        }else{
             self.rows.push({
                section: '',
                section_error_msg:'',
                read_on_wo: {text:'Mandatory',value:'mandatory'},
                read_on_wo_error_msg:'',
                read_on_contract: {text:'Mandatory',value:'mandatory'},
                read_on_contract_error_msg:'',
            });

            // self.deprows.push({
            //     dep_id:0,
            //     pool: '',
            //     deposit_required:'',
            //     deposit_error_msg:'',
            //     pool_error_msg:'',
            // });
        }
        // self.getsectionArr();

        self.loadFieldData(['section','vehicle_pool']);
  },
  methods: {

    BackVehicleList() {
      var self = this;
      self.$router.push("/assettypes/list");
    },

    checkSelected() {
        var self = this;
        if (self.is_default != true) {
            self.checkboxValue = 1;
        } else {
            self.checkboxValue = 0;
        }
    },
    

    CreateVehicleType(flag) {
      var self = this;

        self.code = self.code.trim();
        self.name = self.name.trim();
        var error = false;

      self.name_error_msg = "";
      self.code_error_msg = "";
      self.img_error_msg = "";
      self.type_order_error_msg = "";
      self.trailor_type_error_msg = '';
      self.truck_type_error_msg = '';

      if (self.name == null || self.name == "") {
        self.name_error_msg = "Name required.";
         error = true;
      }
      if ( self.code == null || self.code == "") {
        self.code_error_msg = "Code required.";
         error = true;
      }
      if ( self.typeOrder == null || self.typeOrder == "") {
         self.type_order_error_msg = "Type order required.";
          error = true;
      }
      if ( self.truck_type == null || self.truck_type == "" || !self.truck_type.value) {
         self.truck_type_error_msg = "Truck Type required.";
          error = true;
      }
      if ( self.trailor_type == null || self.trailor_type == "" || !self.trailor_type.value) {
        self.trailor_type_error_msg = "Trailor Type required.";
          error = true;
      }

      if ( self.selectedFile.type ) {

          if ( self.selectedFile.type != 'image/jpeg' && self.selectedFile.type != 'image/png') {
              self.img_error_msg = "Only image files are allowed (.png / .jpeg)";
               error = true;
          }
          if ( self.selectedFile && self.selectedFile.size > 5000000) {
              self.img_error_msg = "File size should not be greater than 5 MB";
               error = true;
          }
      }
      for (var i = 0; i < self.rows.length; i++) {
            // console.log(self.rows[i]);
            self.rows[i].section_error_msg = "";
            self.rows[i].read_on_wo_error_msg = "";
            self.rows[i].read_on_contract_error_msg = "";

            if (self.rows[i].section == null || self.rows[i].section == '' || !self.rows[i].section) {
                    self.rows[i].section_error_msg = "Section is Required.";
                    error = true;
            }

            if (self.rows[i].read_on_wo == null || self.rows[i].read_on_wo == '' || !self.rows[i].read_on_wo) {
                self.rows[i].read_on_wo_error_msg = "Read On WO is Required.";
                error = true;
            }

            if (self.rows[i].read_on_contract == null || self.rows[i].read_on_contract == '' || !self.rows[i].read_on_contract) {
                self.rows[i].read_on_contract_error_msg = "Read On Contract is Required.";
                error = true;
            }

        }

        // self.deprows.push({
        //         dep_id:0,
        //         pool: '',
        //         deposit_required:'',
        //         deposit_error_msg:'',
        //         pool_error_msg:'',
        //     });

        // for (var i = 0; i < self.deprows.length; i++) {
        //     self.deprows[i].pool_error_msg = "";
        //     self.deprows[i].deposit_error_msg = "";

        //     if (self.deprows[i].pool == null || self.deprows[i].pool == '' || !self.deprows[i].pool.value) {
        //             self.deprows[i].pool_error_msg = "Pool is Required.";
        //             error = true;
        //     }

        //     if (self.deprows[i].deposit_required == null || self.deprows[i].deposit_required == '' || !self.deprows[i].deposit_required) {
        //         self.deprows[i].deposit_error_msg = "Deposit is Required.";
        //         error = true;
        //     }
        // }


    //   img_error_msg

      if (!error){

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehicleTypeBtn").val("Updating ...");
                $("#createVehicleTypeBtn").prop("disabled", true);
                $("#cancelVehicleTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehicleTypeBtn").val("Saving ...");
                    $("#createVehicleTypeBtn").prop("disabled", true);
                    $("#createAndContinueVehicleTypeBtn").prop("disabled", true);
                    $("#cancelVehicleTypeBtn").prop("disabled",true);

                }else{

                    $("#createVehicleTypeBtn").val("Saving ...");
                    $("#createVehicleTypeBtn").prop("disabled", true);
                    $("#createAndContinueVehicleTypeBtn").prop("disabled", true);
                    $("#cancelVehicleTypeBtn").prop("disabled",true);
                }

            }
            if (self.typeUrl == 'null' || self.typeUrl == null){
                self.typeUrl = '';
            }
            var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                // formData.append('id',self.add_truck_type_id);
                formData.append('code',self.code);
                formData.append('name',self.name);
                formData.append('type_url',self.typeUrl);

                // if(self.deposit_required != "" && self.deposit_required != null) {
                //   formData.append('deposit_required',self.deposit_required);
                // } else {
                //   formData.append('deposit_required', "");
                // }

                formData.append('specification',self.specification);
                formData.append('is_default',self.checkboxValue);
                formData.append('type_order',self.typeOrder);
                formData.append('truck_type',self.truck_type.value);
                formData.append('trailor_type',self.trailor_type.value);
                formData.append('meter',JSON.stringify(self.rows));
                //  formData.append('deposit',JSON.stringify(self.deprows));
                formData.append('id',segments[3]);

            $.ajax({
                url: process.env.ROOT_API + "/assettypes/create",
                type: "POST",
                // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehicleTypeBtn").val("Update");
                        $("#createVehicleTypeBtn").prop("disabled", false);
                        $("#cancelVehicleTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehicleTypeBtn").val("Save and Continue");
                            $("#createVehicleTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                            $("#cancelVehicleTypeBtn").prop("disabled",false);
                            self.baseimg_path = null;
                            self.typeOrder = "";
                            self.specification = "";
                            $("#typeImage").val("");

                        }else{

                            $("#createVehicleTypeBtn").val("Save");
                            $("#createVehicleTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                            $("#cancelVehicleTypeBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            // $("#VehicleTypeForm").trigger("reset");
                            self.name = "";
                            self.checkboxValue = 0;
                            self.is_default = "";
                            self.code = "";
                            self.truck_type = "";
                            self.trailor_type = "";
                            self.rows = [];
                            self.rows.push({
                                section: '',
                                section_error_msg:'',
                                read_on_wo: '',
                                read_on_wo_error_msg:'',
                                read_on_contract: '',
                                read_on_contract_error_msg:'',
                            });

                        }else{
                            self.$router.push("/assettypes/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                   self.loading = false;
                   if (segments[3])
                    {
                        $("#createVehicleTypeBtn").val("Update");
                        $("#createVehicleTypeBtn").prop("disabled", false);
                        $("#cancelVehicleTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#VehicleTypeForm").trigger("reset");

                            $("#createAndContinueVehicleTypeBtn").val("Save and Continue");
                            $("#createVehicleTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                            $("#cancelVehicleTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehicleTypeBtn").val("Save");
                            $("#createVehicleTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehicleTypeBtn").prop("disabled", false);
                            $("#cancelVehicleTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'asset-type-create')
                }
            });

      }else{
            self.errorValidationFocus();
      }

    },
    addRow: function () {

        var self = this;
        var i = self.rows.length - 1;
        var error = false;
        self.rows[i].section_error_msg = "";
        self.rows[i].read_on_wo_error_msg = "";
        self.rows[i].read_on_contract_error_msg = "";

        if (self.rows[i].section != null && self.rows[i].section != '' && self.rows[i].section.value && self.rows[i].read_on_wo != null &&
            self.rows[i].read_on_wo != '' && self.rows[i].read_on_wo.value && self.rows[i].read_on_contract != null &&
            self.rows[i].read_on_contract != '' && self.rows[i].read_on_contract.value) {

                self.rows.push({
                    section: '',
                    section_error_msg:'',
                    read_on_wo: '',
                    read_on_wo_error_msg:'',
                    read_on_contract: '',
                    read_on_contract_error_msg:'',
                });

        } else {
            if (self.rows[i].section == null || self.rows[i].section == '' || !self.rows[i].section) {
                self.rows[i].section_error_msg = "Section is Required.";
                error = true;
            }

            if (self.rows[i].read_on_wo == null || self.rows[i].read_on_wo == '' || !self.rows[i].read_on_wo) {
                self.rows[i].read_on_wo_error_msg = "Read On WO is Required.";
                error = true;
            }

            if (self.rows[i].read_on_contract == null || self.rows[i].read_on_contract == '' || !self.rows[i].read_on_contract) {
                self.rows[i].read_on_contract_error_msg = "Read On Contract is Required.";
                error = true;
            }
        }
    },
    // addDepRow: function () {

    //     var self = this;
    //     var i = self.deprows.length - 1;
    //     var error = false;
    //     self.deprows[i].pool_error_msg = "";
    //     self.deprows[i].deposit_error_msg = "";

    //     if (self.deprows[i].pool != null && self.deprows[i].pool != '' && self.deprows[i].pool.value && self.deprows[i].deposit_required != null &&
    //         self.deprows[i].deposit_required != '' && self.deprows[i].deposit_required) {

    //             self.deprows.push({
    //                 dep_id:0,
    //                 pool:'',
    //                 pool_error_msg:'',
    //                 deposit_required: '',
    //                 deposit_error_msg:'',
    //             });

    //     } else {
    //        if (self.deprows[i].pool == null || self.deprows[i].pool == '' || !self.deprows[i].pool.value) {
    //             self.deprows[i].pool_error_msg = "Pool is Required.";
    //             error = true;
    //         }

    //         if (self.deprows[i].deposit_required == null || self.deprows[i].deposit_required == '' || !self.deprows[i].deposit_required) {
    //             self.deprows[i].deposit_error_msg = "Deposit is Required.";
    //             error = true;
    //         }
    //     }
    // },
    removeElement: function (index) {
        var self = this;
        if (self.rows.length > 1) {
            self.rows.splice(index, 1);
        }
    },
    

    loadVehicleTypes() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assettypes/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                console.log(data);
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.is_default = data.content.is_default;
                    self.code = data.content.code;
                    self.typeUrl = data.content.type_url;
                    self.deposit_required = data.content.deposit_required;
                    if (data.content.truck_type){
                        var truckTypeIndex = self.ttArr.findIndex(x => (x.value === data.content.truck_type));
                        self.truck_type = self.ttArr[truckTypeIndex];
                    }
                    if (data.content.trailor_type){
                        var trailorTypeIndex = self.trailorTypeArr.findIndex(x => (x.value === data.content.trailor_type));
                        self.trailor_type = self.trailorTypeArr[trailorTypeIndex];
                    }
                    self.typeOrder = data.content.type_order;
                    if( data.content.specification ){
                        self.specification = data.content.specification;
                    }
                    if(data.content.img_path[0] != undefined){

                        self.img_path = data.content.img_path[0].url;

                    }

                    var arrData = data.content.metric;
                    if (arrData){
                        for (var i = 0; i < arrData.length; i++){
                            self.rows.push({
                                section:{text:arrData[i].sectionName+' ('+arrData[i].secCode+')',value:arrData[i].section_id},
                                read_on_wo:{text:self.titleCase(arrData[i].read_on_wo),value:arrData[i].read_on_wo},
                                read_on_contract:{text:self.titleCase(arrData[i].read_on_contract),value:arrData[i].read_on_contract},
                            })
                        }
                    }else{
                        self.rows.push({
                            section: '',
                            section_error_msg:'',
                            read_on_wo: {text:'Mandatory',value:'mandatory'},
                            read_on_wo_error_msg:'',
                            read_on_contract: {text:'Mandatory',value:'mandatory'},
                            read_on_contract_error_msg:'',
                        });
                    }

                    // if (data.content.deposit != undefined && data.content.deposit.length){
                    //     self.deprows = data.content.deposit;
                    // }else{
                    //     self.deprows.push({
                    //         dep_id:0,
                    //         pool:'',
                    //         pool_error_msg:'',
                    //         deposit_required: '',
                    //         deposit_error_msg:'',
                    //     });
                    // }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'asset-type-load-by-id')
            }
        });
    },
    onFileChanged (event) {

        const file = event.target.files[0]
        var self = this;
        //only allow to upload image file
        if ( file.type == "image/png" || file.type == "image/jpeg" ) {

            self.selectedFile = file;

            self.getBase64(self.selectedFile, function(base64Data) {
                self.baseimg_path = base64Data;
            });

        } else {

            $("#typeImage").val("");
            alert("Please select image file");
        }

    },
    getBase64:function(file,callback) {

        const reader = new FileReader();

        reader.addEventListener('load', () => callback(reader.result));

        reader.readAsDataURL(file);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetTypesCreate.vue